import type { MapboxMap } from './mapboxTypes';

type MapListener = (map: MapboxMap | null) => void;

let currentMap: MapboxMap | null = null;
const listeners = new Set<MapListener>();

const notify = (): void => {
  listeners.forEach((listener) => listener(currentMap));
};

/**
 * Tells the hooks that watch the dashboard map that a new instance exists.
 * `createDashboardMapboxMap` calls it, so a hook can add its own layers to the
 * same map without `HomeMapboxMap` handing the instance down.
 */
export const announceDashboardMap = (map: MapboxMap): void => {
  currentMap = map;
  notify();
};

/** Forgets a map that was removed. Another map announced since then stays. */
export const retireDashboardMap = (map: MapboxMap): void => {
  if (currentMap !== map) return;
  currentMap = null;
  notify();
};

/**
 * Calls `listener` with the current map (or null) and again on every change.
 * Returns the function that stops listening.
 */
export const subscribeDashboardMap = (listener: MapListener): (() => void) => {
  listeners.add(listener);
  listener(currentMap);
  return () => {
    listeners.delete(listener);
  };
};
